import { Navigate } from 'react-router-dom';

// Read the `exp` (seconds since epoch) out of a JWT payload, or null if the
// token is malformed / unparseable.
function tokenExp(token) {
  try {
    const payload = JSON.parse(
      atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
}

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  const exp = token && tokenExp(token);
  // Treat a missing, unparseable, or expired token as logged-out so an admin is
  // never dropped into the editor with a dead session (which would otherwise
  // only fail at save time with a 401).
  if (!token || !exp || exp * 1000 <= Date.now()) {
    localStorage.removeItem('token');
    return <Navigate to="/admin/login" replace />;
  }
  return children;
}
